export enum SiRNAProperties {
  Page = 1,
  Count = 10,
  Human = 'Human',
  Mouse = 'Mouse',
  Rat = 'Rat',
  AssayID = 'AssayID',
  ZH = 'zh',
  searchInput = 'EGFR',
  siRNAType = 'Rosetta Predictions',
  Product = 'NM_00528',
  Standard = 'Standard',
  HPLC = 'HPLC',
  Tennmol = '10 nmol',
  Twentynmol = '25 nmol',
  Fiftynmol = '50 nmol',
  S1033 = '1033',
  S1034 = '1034',
  S1030 = '1030',
  P1007 = '1007',
  P1009 = '1009',
  siRNAID = 'siRNAID',
  SeqStart = 'SeqStart',
  SeqType = 'SeqType',
  Purification = 'Purification',
  Size = 'Size',
  Validated = 'validated',
  ValidatedLabel = 'Validated',
  Positive = 'positive',
  PositiveControl = 'Positive Control',
  Predicted = 'predicted',
  PredictedLabel = 'Rosetta Predictions',
  panelLabelValidated = 'siRNAs that have been validated in the lab',
  China = 'CN',
  DEBOUNCE_TIME = 1000,
}

export enum ActiveLinkType {
  selectAssays = 'selectAssays',
  confirmOrder = 'confirmOrder',
  ProductName = 'sirna',
  priceDash = '--',
  Geneknockout = 'geneknockout',
}

export enum DeleteType {
  All = 'All',
  Selected = 'Selected',
}

export enum SemiConfigProperties {
  Quote = 'QUOTE',
  ZeroPrice = 0,
  LoggedInUser = 'LoggedInUser',
  None = 'None',
  Continue = 'continue',
  AddOligo = 'addOligo',
  ErrorUrl = 'https://www.sigmaaldrich.com/webapp/wcs/stores/servlet/UserRegNavigation?storeId=11001',
  Success = 'success',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}

export enum Url {
  CrisprUrl = 'https://www.sigmaaldrich.com/technical-documents/articles/biology/crispr-clone-control-and-cas9-essentials.html#Cas9',
  SequenceUrl = '/semi-configurators/sirna?activeLink=selectAssays',
}

export enum PerPageValues {
  PerPage10 = '10',
  PerPage20 = '20',
  PerPage30 = '30',
  PerPage50 = '50',
  PerPage100 = '100',
  PerPageALL = 'All',
}
